import { getAcId, getUnionId } from "../store/UserStore";

const PostLog = (data) => {
  const body = `
  {"__logs__":${JSON.stringify([data])}}`;
  fetch(
    `https://cjs-service-${
      process.env.PREACT_APP_ENV === "development" ? "test" : "prod"
    }.cn-shenzhen.log.aliyuncs.com/logstores/cjs-client-info/track`,
    {
      method: "POST",
      headers: {
        "x-log-apiversion": "0.6.0",
        "x-log-bodyrawsize": body.length,
      },
      body,
    }
  );
};

const PostStoreLog = async () => {
  const unionId = await getUnionId();
  if(!unionId) {
    setTimeout(()=> PostStoreLog(), 1000);
    return;
  }
  ParamsCache.map((p) => {
    p["da_id"] = `${unionId}`;
    PostLog(p);
  });
  ParamsCache.length = 0;
}
const ParamsCache = [];

const UM = async (params) => {
  const unionId = await getUnionId();
  const search = new URLSearchParams(window.location.search);
  let agent;
  if (params.agent) {
    agent = params.agent;
    delete params.agent;
  }
  const data = {
    da_id: `${unionId}`,
    gh_id: `${search.get("gh_id")}` || `0`,
    sys: "cjs",
    scene: `${search.get("scence")}` || `1`,
    time: `${new Date().valueOf()}`,
    createTime:localStorage.getItem("UserCreateTime")||`null`,
    event: `click`,
    content: JSON.stringify(params),
  };
  const acId = await getAcId();
  if(acId) data.ac_id = `${acId}`;
  if (agent) {
    data.agent = agent;
  }
  if (!unionId) {
    ParamsCache.push(data);
    return;
  }
  PostLog(data);
};
export default UM;